function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 138,
  height: 38,
  rx: 2,
  transform: "matrix(1 0 0 -1 42 93)",
  fill: "#fff"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 156.5,
  y: 81.5,
  width: 2,
  height: 4.5,
  rx: 0.5,
  fill: "#DBDFE5"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M163.086 85.542c-.765.867-3.067.29-4.086 0V82.25c.382-.577 1.368-.924 1.75-2.223.273-.93 1.571-.527 1.571 0s-.382 1.926 0 1.927c.382 0 1.313-.245 1.529 0 .382.432 0 2.722-.764 3.588zM174.438 83l.229.1a.25.25 0 000-.2l-.229.1zm-6.876 0l-.229-.1a.25.25 0 000 .2l.229-.1zM171 85.5a4 4 0 003.667-2.4l-.458-.2A3.5 3.5 0 01171 85v.5zm-3.667-2.4A4 4 0 00171 85.5V85a3.5 3.5 0 01-3.209-2.1l-.458.2zM171 80.5a4 4 0 00-3.667 2.4l.458.2A3.5 3.5 0 01171 81v-.5zm3.667 2.4A4 4 0 00171 80.5v.5a3.5 3.5 0 013.209 2.1l.458-.2z",
  fill: "#DBDFE5"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M171 84a1 1 0 100-2 1 1 0 000 2z",
  stroke: "#DBDFE5",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#0085FF",
  d: "M51 60h124v6H51z"
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 55,
  r: 9.692,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 1.385
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 55,
  r: 9,
  fill: "#DBDFE5"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-newsfeed-content_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 64,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 52.136,
  r: 4.345,
  stroke: "#DBDFE5",
  strokeWidth: 1.325
}));
var _ref0 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#0085FF",
  d: "M51 69h40v6H51z"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "#DBDFE5",
  d: "M51 78h34v10H51zM88 78h34v10H88z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M55.525 85.254l2.784-2.784s.663-.663-.133-1.459c-.795-.795-1.458-.132-1.458-.132l-2.784 2.784s-.528.533 0 1.06c.557.558 1.06 0 1.06 0l2.52-2.518c.265-.266.397-.398.132-.663-.265-.266-.398-.133-.663.132l-2.386 2.387M92.525 85.254l2.784-2.784s.663-.663-.133-1.459c-.795-.795-1.458-.132-1.458-.132l-2.784 2.784s-.528.533 0 1.06c.557.558 1.06 0 1.06 0l2.52-2.518c.265-.266.397-.398.132-.663-.265-.266-.398-.133-.663.132l-2.386 2.387",
  stroke: "#A0AFBE",
  strokeWidth: 0.375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgEmptyNewsfeedContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "empty-newsfeed-content_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 46,
    width: 18,
    height: 18
  }, _ref8), _ref9, _ref0, _ref1, _ref10);
}
export default SvgEmptyNewsfeedContent;